import styled from 'styled-components';
import InputField from '../../../components/Form/InputField';
import { PrimaryButton } from '../../../components/Button';
import { theme } from '../../../styles/theme';

export const AuthFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 100%;
`;
export const AuthFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;
export const AuthFieldLabel = styled.div`
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  color: ${theme.colors.secondary900};
`;
export const FlexAuthFieldLabel = styled(AuthFieldLabel)`
  display: flex;
  justify-content: space-between;
`;
export const AuthInputField = styled(InputField)`
  min-height: 48px;
  font-size: 14px;
  &::placeholder {
    font-size: 14px;
  }
`;
export const AuthFormLink = styled.button`
  display: inline-block;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  outline: none;
  font: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  color: ${theme.colors.mainBlue};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
export const AuthSubmitButton = styled(PrimaryButton)`
  width: 100%;
  min-height: 52px;
  margin-top: 8px;
  font-size: 16px;
`;
export const AuthFormHint = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${theme.colors.secondary800};
`;
